<template>
	<div></div>
</template>

<script>
	import { mapActions } from 'vuex';

	export default {
		name: 'TheDashboard',
		methods: {
			...mapActions('header', ['setupHeader',]),
			setup() {
				let header = '';
				this.setupHeader({ header });
			}
		},
		mounted() {
			this.setup();
		},
		created() {
			if (localStorage.getItem('reloaded')) {
				// The page was just reloaded. Clear the value from local storage
				// so that it will reload the next time this page is visited.
				localStorage.removeItem('reloaded');
			} else {
				// Set a flag so that we know not to reload the page twice.
				localStorage.setItem('reloaded', '1');
				location.reload();
			}
		}
	};
</script>

<style>
	@import url("https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,400i,700&display=fallback");
</style>
